module.exports = __webpack_public_path__ + "static/scale-model-of-hollywood-walk-of-fame-in-los-angeles-california-f5d1b26900122117ef3592e246cdf770.png";